import { Mutex } from 'async-mutex'
import { cancelled } from 'redux-saga/effects'
import Logger from './logger.service'

const globalMutex = new Mutex()

export function* performWithMutexHOG(saga: any, action: any) {
  try {
    yield globalMutex.acquire().catch((mutexErr) => {
      Logger.errorObj(`Error acquiring mutex for saga: ${saga.name}`, mutexErr)
    })
    yield saga(action)
  } catch (error) {
    Logger.errorObj(`Error in performWithMutexHOG for saga: ${saga.name}`, error)
  } finally {
    if (yield cancelled()) {
      yield globalMutex.release()
    } else {
      yield globalMutex.release()
    }
  }
}
